import React, { useMemo, useState } from 'react';
import '../styles/Events.css';

const photoPlaceholders = [
  { id: 1, src: '/images/events/Patent_Cover.jpg' },
  { id: 2, src: '/images/events/patent_page1.JPG' },
  { id: 3, src: '/images/events/IMG_6264.JPG' },
  { id: 4, src: '/images/events/IMG_6266.JPG' },
  { id: 5, src: '/images/events/IMG_6250.JPG' },
  { id: 6, src: '/images/events/IMG_6254_removed.JPG' },
  // { id: 7, src: '/images/events/IMG_6256.JPG' },
  { id: 8, src: '/images/events/IMG_6267.JPG' },
  { id: 9, src: '/images/events/IMG_6265_cropped.JPG' },
  { id: 10, src: '/images/events/IMG_6263_cropped.JPG' },
  { id: 11, src: '/images/events/IMG_7661.jpg' },
  { id: 12, src: '/images/events/Patent_Party_JG_1-cropped.jpg' },
  { id: 13, src: '/images/events/IMG_6259_cropped.JPG' },
  { id: 14, src: '/images/events/IMG_6257.JPG' },
];
export default function PatentCelebrationGallery() {
  const [hoverPreview, setHoverPreview] = useState(null);
  const [mobilePreview, setMobilePreview] = useState(null);

  const isTouchDevice = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return (
      'ontouchstart' in window ||
      (navigator && navigator.maxTouchPoints > 0) ||
      window.matchMedia?.('(hover: none)').matches
    );
  }, []);

  const openMobilePreview = (photo) => {
    if (photo.src === 'XYZ') return;
    setMobilePreview({
      src: photo.src,
      alt: `Celebration photo ${photo.id}`,
    });
  };

  const closeMobilePreview = () => setMobilePreview(null);

  return (
    <div className="patent-page">
      <div className="patent-page__bg-orb patent-page__bg-orb--1" />
      <div className="patent-page__bg-orb patent-page__bg-orb--2" />

      {/* Desktop centered hover preview */}
      {hoverPreview && !isTouchDevice && (
        <div className="hover-zoom-overlay" aria-hidden="true">
          <div className="hover-zoom-overlay__backdrop" />
          <div className="hover-zoom-overlay__panel">
            <img
              className="hover-zoom-overlay__img"
              src={hoverPreview.src}
              alt={hoverPreview.alt}
            />
          </div>
        </div>
      )}

      {/* Mobile / touch preview modal */}
      {mobilePreview && (
        <div
          className="mobile-image-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
          onClick={closeMobilePreview}
        >
          <div className="mobile-image-modal__backdrop" />
          <div
            className="mobile-image-modal__frame"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="mobile-image-modal__close"
              onClick={closeMobilePreview}
              aria-label="Close image preview"
            >
              ✕
            </button>
            <img
              className="mobile-image-modal__img"
              src={mobilePreview.src}
              alt={mobilePreview.alt}
            />
          </div>
        </div>
      )}

      <header className="patent-hero">
        <h1 className="patent-hero__title">
          Celebrating Our Foundational Patent
        </h1>
        <p className="patent-hero__subtitle">
          SleepDev team and families celebrating our&nbsp;
          <a
            href="https://ppubs.uspto.gov/api/pdf/downloadPdf/12551164?requestToken=eyJzdWIiOiJhMGIwNmQ5Zi05MWI1LTQyMGItOWFlOC0yMjJlYmI3ZTYyNTAiLCJ2ZXIiOiIyYTUzMTk5NS1hYzgzLTQwMTMtYTUwYy04ZmY5MmMwZDgzNzUiLCJleHAiOjB9"
            target="blank"
          >
            granted patent
          </a>{' '}
          with bocce ball, food, and drinks.
        </p>
      </header>
      {/* 
      <section className="event-note" aria-label="Event summary">
        <h2 className="section-title">Event Highlights</h2>
        <p>
          SleepDev rented bocce ball courts at Campo di Bocce for fun and games
          to celebrate our first patent. Team members and families joined for
          Italian bowling, food, and drinks, with a flexible drop-in format from
          12:30 PM through 2:00 PM. For those too far away to attend, we raised
          an honorary toast in your honor.
        </p>
      </section> */}

      <section
        className="gallery-section"
        aria-label="Photo gallery placeholders"
      >
        <div className="photo-grid">
          {photoPlaceholders.map((photo, index) => {
            const topRowClass =
              index === 0
                ? ' photo-card--top-left'
                : index === 1
                  ? ' photo-card--top-right'
                  : '';

            const isRealImage = photo.src !== 'XYZ';

            return (
              <figure key={photo.id} className={`photo-card${topRowClass}`}>
                <div className="photo-card__frame">
                  {isRealImage ? (
                    <img
                      className="photo-card__image"
                      src={photo.src}
                      alt={`Celebration photo ${photo.id}`}
                      onMouseEnter={() => {
                        if (isTouchDevice) return;
                        setHoverPreview({
                          src: photo.src,
                          alt: `Celebration photo ${photo.id}`,
                        });
                      }}
                      onMouseLeave={() => {
                        if (isTouchDevice) return;
                        setHoverPreview(null);
                      }}
                      onClick={() => {
                        if (isTouchDevice) openMobilePreview(photo);
                      }}
                    />
                  ) : (
                    <div
                      className="photo-card__placeholder"
                      aria-label={`Placeholder image slot ${photo.id}`}
                    >
                      <div className="photo-card__placeholder-icon">📷</div>
                      <div className="photo-card__placeholder-text">
                        Image {photo.id}
                      </div>
                      <div className="photo-card__placeholder-subtext">
                        Paste image path here
                      </div>
                      <code className="photo-card__placeholder-code">XYZ</code>
                    </div>
                  )}
                </div>
              </figure>
            );
          })}
        </div>
      </section>

      <footer className="patent-footer">
        <div className="patent-footer__line" />
        <p>SleepDev • 1st Patent Celebration • Photo Share Page</p>
      </footer>
    </div>
  );
}
